var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 506,
    viewBox: "0 0 560 506",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.612 141.057L319.417 133.913L296.491 147.379L300.666 154.523L287.546 177.643L279.272 177.701L279.464 204.307L287.738 204.25L301.203 227.178L297.123 234.381L320.241 247.502L324.34 240.319L350.924 240.127L355.119 247.253L378.045 233.787L373.87 226.661L386.99 203.522L395.264 203.464L395.072 176.858L386.798 176.935L373.333 153.987L377.413 146.804L354.295 133.664L350.196 140.866L323.612 141.057Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M337.115 169.311C348.875 169.234 358.47 178.678 358.547 190.439C358.624 202.2 349.181 211.797 337.421 211.873C325.661 211.95 316.065 202.507 315.989 190.745C315.912 178.984 325.355 169.388 337.115 169.311Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9031 57.7523C61.9031 57.7523 9.86397 103.226 67.5341 161.055",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.22 6.22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.28 310.579C8.772 323.355 -7.37411 335.634 4.1944 353.41C12.1813 365.669 28.2125 370.036 21.9685 387.448C19.4978 394.344 14.7669 399.573 16.1843 407.331C17.4292 414.093 22.7155 419.418 27.3697 424.072C31.3727 428.076 37.8082 431.849 40.7769 436.753C45.6418 444.741 40.662 450.755 38.3636 458.685C36.161 466.252 35.8163 474.603 40.0108 481.671C45.5652 491.019 56.4059 491.958 63.55 498.796C63.55 498.796 96.3977 520.269 109.843 480.637C113.023 471.27 117.734 462.689 115.455 452.077C113.731 444.051 107.794 438.151 101.033 434.09C93.9461 429.838 86.2274 428.804 84.3504 419.648C83.2012 414.035 85.3463 406.89 85.557 401.24C85.806 394.65 86.055 387.142 82.3776 381.357C78.1447 374.691 71.1155 374.078 64.6034 370.707C48.1892 362.183 56.9805 348.085 54.4906 333.661C50.8898 312.763 30.7024 314.755 16.5099 310.483L16.28 310.579Z",
    fill: "#C7D0D9",
    stroke: "#C7D0D9",
    strokeWidth: 0.1554,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3618 343.506L92.2416 503.815",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0242 398.979L56.8658 413.652",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.52 473.952L93.9655 451.771",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5725 392.486L55.1612 372.335",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9819 307.38H197.737V232.159L70.9819 251.103V307.38Z",
    fill: "#4D53E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1431 504.619L88.9283 484.257H105.649V504.619H69.1431Z",
    fill: "#4D53E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M177.991 504.619L165.177 484.257H148.476V504.619H177.991Z",
    fill: "#4D53E0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M187.778 306.997V489.659H136.505V343.947H129.82L120.435 489.659H69.1431L78.5473 343.947L80.9414 306.997H187.778Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M212.198 216.739C212.198 174.502 179.868 155.673 137.654 154.677C136.792 154.657 135.911 154.638 135.03 154.638C71.5182 154.638 51.4839 200.802 48.4769 208.77C41.7733 226.508 22.9266 282.134 83.6613 307.859C101.933 315.598 114.996 296.826 124.745 291.807C141.753 283.053 147.882 280.87 147.882 280.87L212.198 216.739Z",
    fill: "#4D53E0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M184.062 237.771C184.062 237.771 190.842 268.649 228.708 261.983C266.574 255.317 255.503 197.067 255.503 197.067H226.199L225.126 223.864C225.126 223.864 209.593 183.581 190.114 169.771C178.259 161.362 184.062 237.771 184.062 237.771Z",
    fill: "#4D53E0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M197.278 225.665V257.711",
    stroke: "white",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M109.518 300.944L120.167 311.671L128.748 321.823L125.147 325.443L128.326 329.619L110.533 343.449L87.396 315.655L109.518 300.944Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M124.611 332.282L116.969 323.566",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M119.612 335.73L111.95 326.995",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M114.881 339.503L107.239 330.768",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M125.243 325.616L119.612 319.103",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9799 227.274C64.9104 261.581 114.172 299.354 114.172 299.354L84.6956 321.325C84.6956 321.325 45.0869 287.804 43.0566 265.124",
    fill: "#4D53E0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M131.468 135.847C131.468 135.847 112.698 140.713 111.587 117.88C110.457 95.0663 147.097 86.8296 155.716 96.3688C164.334 105.908 131.468 135.847 131.468 135.847Z",
    fill: "#4D53E0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M133.23 167.012C139.627 167.012 144.798 161.821 144.798 155.443V117.822H121.661V155.443C121.661 161.841 126.832 167.012 133.23 167.012Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M113.521 119.7C113.234 123.243 115.877 126.346 119.42 126.634C119.976 126.672 120.512 126.653 121.029 126.557C121.278 128.913 122.025 131.154 123.155 133.127C125.856 137.916 130.816 141.306 136.716 141.785C146.158 142.551 154.432 135.502 155.179 126.059C155.945 116.616 148.897 108.341 139.455 107.594C133.057 107.076 127.196 110.141 123.864 115.122C122.925 114.375 121.757 113.915 120.474 113.8C116.911 113.532 113.808 116.156 113.521 119.7Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M123.059 122.956C123.059 122.956 123.117 119.7 119.899 119.891",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M488.08 195.649H166.25V504.619H488.08V195.649Z",
    fill: "#FFC405"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M230.834 184.443L231.026 202.43L253.531 202.315L254.01 184.616L230.834 184.443Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M235.565 202.123L235.871 190.516",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M241.618 201.549L241.924 189.96",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M247.651 201.434L247.957 189.826",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M80.98 227.274C64.9105 261.581 114.172 299.354 114.172 299.354",
    stroke: "white",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M444.966 254.34H209.919V290.486H444.966V254.34Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M444.966 305.656H209.919V341.802H444.966V305.656Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M444.966 358.562H209.919V394.708H444.966V358.562Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M398.194 420.375H256.691V456.521H398.194V420.375Z",
    fill: "#FF5668"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M439.354 173.123C464.318 173.123 484.556 152.883 484.556 127.917C484.556 102.951 464.318 82.7112 439.354 82.7112C414.39 82.7112 394.153 102.951 394.153 127.917C394.153 152.883 414.39 173.123 439.354 173.123Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.22 6.22"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9104 504.504H559.406",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M512.5 504.504H433.666L422.94 416.698H523.207L512.5 504.504Z",
    fill: "#4D53E0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M529.891 416.698H416.275V436.715H529.891V416.698Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M473.083 416.698V327.225",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M473.083 369.442C500.65 369.442 522.996 347.093 522.996 319.524C522.996 291.956 500.65 269.607 473.083 269.607C445.517 269.607 423.17 291.956 423.17 319.524C423.17 347.093 445.517 369.442 473.083 369.442Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M501.432 347.886C517.094 332.222 517.094 306.826 501.432 291.162C485.769 275.498 460.376 275.498 444.713 291.162C429.05 306.826 429.05 332.222 444.713 347.886C460.376 363.55 485.769 363.55 501.432 347.886Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M473.083 416.487C473.083 416.487 473.083 378.426 434.489 373.714C431.272 405.454 473.083 416.487 473.083 416.487Z",
    fill: "#4D53E0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M442.649 384.287L463.947 405.071",
    stroke: "white",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M473.256 416.908C473.256 416.908 473.256 378.848 511.849 374.135C515.086 405.875 473.256 416.908 473.256 416.908Z",
    fill: "#4D53E0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M503.69 384.709L482.392 405.511",
    stroke: "white",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M456.937 313.835V324.926C456.937 334.044 464.273 341.419 473.39 341.419C482.506 341.419 489.88 334.025 489.88 324.926V313.835H456.937ZM475.362 330.788H471.417V322.379H475.362V330.788Z",
    fill: "#4D53E0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M483.675 310.656V308.51C483.675 302.84 479.078 298.224 473.39 298.224C467.72 298.224 463.104 302.821 463.104 308.51V310.656",
    stroke: "#4D53E0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M507.425 261.274C507.425 261.274 540.598 201.434 481.338 168.085",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.22 6.22"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M299.364 138.107L297.506 123.818L293.063 124.412L284.29 112.976L286.014 108.839L272.703 103.303L270.998 107.44L256.71 109.298L253.99 105.736L242.556 114.489L245.275 118.052L239.74 131.346L235.297 131.94L237.154 146.229L241.598 145.655L250.351 157.09L248.627 161.228L261.939 166.763L263.662 162.626L277.951 160.768L280.67 164.331L292.105 155.577L289.385 152.014L294.92 138.701L299.364 138.107ZM268.815 146.459C262.494 147.283 256.71 142.839 255.886 136.537C255.063 130.216 259.506 124.431 265.827 123.607C272.147 122.783 277.932 127.227 278.755 133.549C279.579 139.851 275.135 145.635 268.815 146.459Z",
    fill: "#4D53E0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M280.422 0.593811H80.52V57.7523H280.422V0.593811Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.22 6.22"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M110.514 37.9844C115.38 37.9844 119.324 34.0394 119.324 29.1731C119.324 24.3067 115.38 20.3618 110.514 20.3618C105.648 20.3618 101.703 24.3067 101.703 29.1731C101.703 34.0394 105.648 37.9844 110.514 37.9844Z",
    fill: "#C7D0D9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M138.362 37.9844C143.228 37.9844 147.173 34.0394 147.173 29.1731C147.173 24.3067 143.228 20.3618 138.362 20.3618C133.497 20.3618 129.552 24.3067 129.552 29.1731C129.552 34.0394 133.497 37.9844 138.362 37.9844Z",
    fill: "#C7D0D9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M166.211 37.9844C171.077 37.9844 175.022 34.0394 175.022 29.1731C175.022 24.3067 171.077 20.3618 166.211 20.3618C161.345 20.3618 157.401 24.3067 157.401 29.1731C157.401 34.0394 161.345 37.9844 166.211 37.9844Z",
    fill: "#C7D0D9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M194.06 37.9844C198.926 37.9844 202.87 34.0394 202.87 29.1731C202.87 24.3067 198.926 20.3618 194.06 20.3618C189.194 20.3618 185.25 24.3067 185.25 29.1731C185.25 34.0394 189.194 37.9844 194.06 37.9844Z",
    fill: "#C7D0D9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M221.928 37.9844C226.794 37.9844 230.738 34.0394 230.738 29.1731C230.738 24.3067 226.794 20.3618 221.928 20.3618C217.062 20.3618 213.117 24.3067 213.117 29.1731C213.117 34.0394 217.062 37.9844 221.928 37.9844Z",
    fill: "#C7D0D9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M258.587 29.1731C258.587 34.0384 254.641 37.9844 249.777 37.9844C244.912 37.9844 240.966 34.0384 240.966 29.1731C240.966 24.3077 244.912 20.3618 249.777 20.3618C254.641 20.3618 258.587 24.3077 258.587 29.1731Z",
    fill: "#C7D0D9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M453.317 128.645C448.95 133.012 441.883 133.012 437.516 128.645C433.149 124.278 433.149 117.209 437.516 112.842C441.883 108.475 448.95 108.475 453.317 112.842C457.684 117.209 457.684 124.297 453.317 128.645Z",
    fill: "#4D53E0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M445.426 120.753L425.986 140.176L432.057 146.248",
    stroke: "#4D53E0",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M435.926 139.18L431.463 134.717",
    stroke: "#4D53E0",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M449.621 124.948C447.303 127.266 443.549 127.266 441.212 124.948C438.895 122.63 438.895 118.876 441.212 116.539C443.53 114.221 447.284 114.221 449.621 116.539C451.938 118.876 451.938 122.63 449.621 124.948Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImage);
export default __webpack_public_path__ + "static/media/loginImage.f6d04a8ff0512eb89c20a66fa8907a1b.svg";
export { ForwardRef as ReactComponent };